import React, { useMemo, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import * as chanceApi from '../../../lib/api/chance';
import { setProject } from '../../../modules/projectModule/project';
import ProjectDetailForm from '../../../components/projectmng/detail/ProjectDetailForm';

const ProjectDetailFormContainer = ({ project }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const validationSchema = Yup.object().shape({
    prjTyp: Yup.string().required('프로젝트 타입을 선택하세요'),
    crtUsr: Yup.string().required('영업 담당자를 선택하세요'),
    expDay: Yup.date().nullable().required('매출 예상일을 선택하세요'),
    incTyp: Yup.string().required('거래처 유형을 선택하세요'),

    // not required
    forcastTxt: Yup.string(),
  });

  const defaultValues = useMemo(
    () => ({
      expDay: project?.expDay || new Date(),
      crtUsr: project?.crtUsr || '',
      crtNm: project?.crtNm || '',
      prjTyp: project?.prjTyp || '',
      incTyp: project?.incTyp || '',
      forcastTxt: project?.forcastTxt || '',
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [project],
  );

  useEffect(() => {
    if (project) {
      formik.resetForm(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  const formik = useFormik({
    initialValues: defaultValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      //   console.log(values, 'values');
      //   formik.resetForm();
      // console.log(values, 'values');
      setSubmitting(false);
    },
  });

  const onSave = async (values) => {
    const isChangePrjTyp = project.prjTyp !== values.prjTyp ? true : false;

    const NewProjectData = {
      prjUuid: project?.prjUuid,
      expDay: dayjs(values.expDay).format('YYYY-MM-DD'),
      crtUsr: values?.crtUsr,
      prjTyp: values?.prjTyp,
      incTyp: values?.incTyp,
      forcastTxt: values?.forcastTxt,
    };

    try {
      const res = await chanceApi.editChance(NewProjectData);

      if (res.data) {
        dispatch(setProject(res.data.info));
        enqueueSnackbar(`기본사항 저장 성공`, {
          variant: 'success',
        });

        if (isChangePrjTyp) {
          const url =
            values.prjTyp === 'N'
              ? `/projectmng/${project?.prjUuid}/${project.cmpGrade}/1`
              : `/maintancetmng/${project?.prjUuid}/${project.cmpGrade}/1`;
          navigate(url);
        }
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return <ProjectDetailForm formik={formik} project={project} />;
};

export default ProjectDetailFormContainer;
